import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import Filter from 'views/machine/reports/user_affiliates/filterReports'; // Importing Filter component
import Table from 'views/machine/reports/user_affiliates/tableReports'; // Importing Table component
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * ReportView class extending JetView to create a report interface.
 */
export default class ReportView extends JetView {
    /**
     * Configures the UI components of the ReportView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Current theme configuration
        const right = {
            type: 'wide',
            rows: [],
        };
        /**
         * Toolbar configuration with pagination and export options.
         */
        const toolbar = {
            view: 'toolbar',
            id: 'toolbar1',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'select', // Dropdown for selecting number of items per page
                    options: ['10', '20', '50', '100'],
                    width: 70,
                    on: {
                        onChange: function () {
                            // Event handler for changing page size
                            $$('datatable').getPager().config.size = this.getValue() * 1; // Update pager size
                            $$('datatable').refresh(); // Refresh data table
                        },
                    },
                },
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: devConfig.getDefaultDataFetch(), // Default fetch size from config
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export1',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for export dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Excel export option
                        { id: '2', value: 'PDF' }, // PDF export option
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export selection
                            var size = $$('datatable').getPager().config.size; // Current page size
                            var page = $$('datatable').getPage(); // Current page number
                            var first = size * page; // First item index on current page
                            var last = first + size - 1; // Last item index on current page
                            if (value == 1) {
                                // If Excel is selected
                                var table = $$('datatable'); // Reference to the data table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    filter: function (obj) {
                                        // Filter function for export
                                        return (
                                            $$('datatable').getIndexById(obj.id) >= first &&
                                            $$('datatable').getIndexById(obj.id) <= last
                                        );
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Usuarios'),
                                    ignore: { detailTittle: true, Type: true }, // Ignore specific fields
                                    footer: false, // Do not include footer in export
                                });
                            } else {
                                if (value == 2) {
                                    // If PDF is selected
                                    webix.toPDF($$('datatable'), {
                                        // Export to PDF
                                        filter: function (obj) {
                                            // Filter function for export
                                            return (
                                                $$('datatable').getIndexById(obj.id) >= first &&
                                                $$('datatable').getIndexById(obj.id) <= last
                                            );
                                        },
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Usuarios'),
                                        autowidth: true, // Automatically adjust width
                                        ignore: {
                                            detailTittle: true,
                                            Type: true,
                                        },
                                        footer: false, // Do not include footer in export
                                    });
                                }
                            }
                            $$('Export1').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };
        const left = {
            Width: 250,
            responsiveCell: false,
            rows: [
                {
                    view: 'toolbar', // Toolbar for the left section
                    css: theme,
                    elements: [
                        { view: 'label', label: _('Usuarios'), width: 300 }, // Label for users
                    ],
                },
                Filter, // Filter component
                Table, // Table component
                toolbar, // Toolbar component
            ],
        };
        webix.ui.fullScreen(); // Set UI to full screen mode
        return {
            type: 'wide',
            responsive: true,
            css: 'out',
            cols: [left], // Main layout with left section
        };
    }
}

// FILE DOCUMENTED
